const yotpoApiKey = '6NVH7lTp14MZw8vVh2h79hz9URw1cWyFltTLgJ6Z';


if (!customElements.get('product-info')) {
  customElements.define('product-info', class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.quantity__input');
      this.currentVariant = this.querySelector('.product-variant-id');
      this.variantSelects = this.querySelector('variant-radios')
      this.submitButton = this.querySelector('[type="submit"]');
    }

    cartUpdateUnsubscriber = undefined;
    variantChangeUnsubscriber = undefined;

    connectedCallback() {
      if (!this.input) return;
      this.quantityForm = this.querySelector('.product-form__quantity');
      if (!this.quantityForm) return;
      this.setQuantityBoundries();
      if (!this.dataset.originalSection) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
      }
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        if (event.data.sectionId !== sectionId) return;
        this.updateQuantityRules(event.data.sectionId, event.data.html);
        this.setQuantityBoundries();
      });

      // this.checkProductPriceList();
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }

    setQuantityBoundries() {
      const data = {
        cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
        min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
        max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
        step: this.input.step ? parseInt(this.input.step) : 1
      }

      let min = data.min;
      const max = data.max === null ? data.max : data.max - data.cartQuantity;
      if (max !== null) min = Math.min(min, max);
      if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

      this.input.min = min;
      this.input.max = max;
      this.input.value = min;
      publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
    }

    fetchQuantityRules() {
      if (!this.currentVariant || !this.currentVariant.value) return;
      this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
      fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`).then((response) => {
        return response.text()
      })
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.updateQuantityRules(this.dataset.section, html);
          this.setQuantityBoundries();
        })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
        });
    }

    updateQuantityRules(sectionId, html) {
      const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
      const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
      for (let selector of selectors) {
        const current = this.quantityForm.querySelector(selector);
        const updated = quantityFormUpdated.querySelector(selector);
        if (!current || !updated) continue;
        if (selector === '.quantity__input') {
          const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
          for (let attribute of attributes) {
            const valueUpdated = updated.getAttribute(attribute);
            if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
          }
        } else {
          current.innerHTML = updated.innerHTML;
        }
      }
    }
    formatShopifyPrice(priceInCents, locale = 'en-US') {
      const price = priceInCents / 100;

      // Séparer entier et centimes
      const [whole, cents] = price.toFixed(2).split('.');

      // Formater selon la locale passée (ex : 'fr-CA' => 3 300)
      const formattedWhole = Number(whole).toLocaleString(locale);

      // Créer les éléments HTML
      const span = document.createElement('span');
      span.className = 'price-item price-item--regular';
      span.setAttribute('aria-hidden', 'true');

      const wholeSpan = document.createElement('span');
      wholeSpan.className = 'whole-number';
      wholeSpan.textContent = formattedWhole;

      const centsSpan = document.createElement('span');
      centsSpan.className = 'cents';
      centsSpan.textContent = cents;

      span.appendChild(wholeSpan);
      span.appendChild(centsSpan);

      return span;
    }


  }
  )
};

document.addEventListener('DOMContentLoaded', event => {


  const reviewsSection = document.getElementById('reviews');
  const reviewsLoadMoreButton = reviewsSection.querySelector('button[data-load-more]');
  const reviewsWrapper = reviewsSection.querySelector('.reviews-wrapper');
  const reviewsPerPage = 10;
  let reviewsCurrentPage = parseInt(reviewsSection.dataset.currentPage);

 
  displayReviews(
    reviewsSection,
    true,
    reviewsWrapper,
    new URLSearchParams(
      {
        per_page: reviewsPerPage
      }
    )
  )
    .then(data => {
      if (data.response.pagination.total < 3) {
        reviewsLoadMoreButton.style.display = 'none';
      }
    })
    .catch(error => {
      reviewsLoadMoreButton.style.display = 'none';
      document.querySelector('#Reviews-formSubmissionErrors').innerText = reviewsSection.dataset.reviewsUnavailableTranslation;
      console.error(error);
    });
 
  if (reviewsLoadMoreButton) reviewsLoadMoreButton.addEventListener('click', event => {
    reviewsSection.classList.add('loaded');

    focusUnfocusableElement(reviewsWrapper.children[2]);

    if (reviewsWrapper.children.length < reviewsPerPage) {
      reviewsLoadMoreButton.style.display = 'none';
    } else if (reviewsCurrentPage > 1) {
      displayReviews(
        reviewsSection,
        true,
        reviewsWrapper,
        new URLSearchParams(
          {
            page: reviewsCurrentPage,
            per_page: reviewsPerPage
          }
        )
      )
        .then(data => {
          reviewsSection.dataset.currentPage = reviewsCurrentPage++;
          focusUnfocusableElement(
            reviewsWrapper.children[
            (data.response.pagination.page - 1) * data.response.pagination.per_page
            ]
          )
        })
        .finally(() => {
          if (reviewsWrapper.children.length >= reviewsSection.dataset.totalReviews) {
            reviewsLoadMoreButton.style.display = 'none';
          }
        })
    } else {
      reviewsSection.dataset.currentPage = ++reviewsCurrentPage;
    }
  });

 
  document.querySelector('#ReviewForm').addEventListener('submit', event => {
    event.preventDefault();

    let formAlertElement = document.querySelector('#ReviewFormAlert');
    let formData = Object.fromEntries(new FormData(event.srcElement));

    formData.appkey = yotpoApiKey;
    formData.review_score = Number(formData.review_score);

    fetch(
      'https://api.yotpo.com/v1/widget/reviews',
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }
    )
      .then(response => formAlertElement.innerText = reviewsSection.dataset.reviewSubmissionSuccess)
      .catch(error => {
        formAlertElement.innerText = reviewsSection.dataset.reviewSubmissionError;
        console.error(error);
      })
      .finally(() => {
        Array.from(event.target.children).forEach(element => {
          if (element.id != "QandAFormAlert") element.style.display = 'none';
        })
      });
  });
});

function thumbIcon(direction = "up") {
  return `<svg class="icon icon-thumb ${direction}" aria-hidden="true" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.78668 15.8334H4.21334C3.72751 15.8334 3.33334 15.4392 3.33334 14.9534V8.79675C3.33334 8.31091 3.72751 7.91675 4.21334 7.91675H5.78668C6.27251 7.91675 6.66668 8.31091 6.66668 8.79675V14.9534C6.66668 15.4392 6.27251 15.8334 5.78668 15.8334V15.8334Z" stroke="#2A2B2A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6.66666 8.81005L9.70749 4.85089C10.2733 4.11339 11.3783 4.09505 11.9692 4.81255V4.81255C12.19 5.08005 12.31 5.41672 12.31 5.76339V8.48922H14.89C15.3908 8.48922 15.8583 8.73922 16.1367 9.15505L16.4108 9.56422C16.6567 9.93172 16.7283 10.3892 16.6058 10.8134L15.4733 14.7484C15.2883 15.3909 14.7008 15.8334 14.0325 15.8334H8.79166C8.37499 15.8334 7.97666 15.6601 7.69332 15.3551L6.66666 14.2501" stroke="#2A2B2A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>`
}

async function displayReviews(reviewsSection, displayLoadMore, reviewsWrapper, urlSearchParams, apiKey = yotpoApiKey) {
  let errorsElement = document.getElementById('Reviews-formSubmissionErrors');

  if (reviewsSection.dataset.productId) {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000);

    if (displayLoadMore) reviewsSection.classList.add('load-more');

    return fetch(
      `https://api-cdn.yotpo.com/v1/widget/${apiKey}/products/${reviewsSection.dataset.productId}/reviews.json?${urlSearchParams && urlSearchParams.toString()}`,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        signal: controller.signal
      }
    )
      .then(response => {
        clearTimeout(timeoutId);

        if (!response.ok) throw new Error("Yotpo error. Refer to Yotpo response for more details.");

        return response.json();
      })
      .then(data => {
        document.getElementById('Reviews-formSubmissionInfo').style.display = 'block';

        if (!data.response.pagination.total) {
          errorsElement.innerText = reviewsSection.dataset.reviewsUnavailableTranslation;
        }
        data.response.reviews.forEach(review => {
          const localizedReviewDate = localizedSubmissionDate(review.created_at);
          let currentReviewsWrapper = reviewsWrapper ?? reviewsSection;

          reviewsSection.dataset.totalReviews = data.response.pagination.total;

          currentReviewsWrapper.insertAdjacentHTML(
            'beforeend',
            `<figure class="review" id="review-${review.id}" data-review-id="${review.id}">
          <blockquote>
            <h3>${review.title}</h3>
            <span class="reviewed-on-wrapper">
              <span class="reviewed-on visually-hidden">${reviewsSection.dataset.reviewedOnTranslation}</span> <time datetime="${review.created_at}">${localizedReviewDate}</time>
            </span>
            <div class="rating" role="img" aria-label="${review.score} out of 5 stars">
              <span aria-hidden="true" class="rating-star color-icon-text" style="--rating: ${review.score}; --rating-max: 5; --rating-decimal: 0.5;"></span>
            </div>
            <p class="content">${review.content}</p>
          </blockquote>
          <figcaption>
            <span class="visually-hidden">${reviewsSection.dataset.reviewedByTranslation}</span> ${review.user.display_name}
          </figcaption>
          <form class="helpful-form">
            <fieldset>
              <legend>
                ${reviewsSection.dataset.helpfulTranslation}
              </legend>
              <span class="visually-hidden">
                ${reviewsSection.dataset.helpfulFormSubmissionInfoTranslation}
              </span>
              <label class="helpful-input-wrapper up">
                <input 
                  type="radio" 
                  name="helpful" 
                  value="up" 
                  aria-label="${reviewsSection.dataset.yesTranslation}"
                >
                ${thumbIcon()}
              </label>
              <label class="helpful-input-wrapper down">
                <input 
                  type="radio" 
                  name="helpful" 
                  value="down"
                  aria-label="${reviewsSection.dataset.noTranslation}"
                >
                ${thumbIcon("down")}
              </label>
            </fieldset>
            <p class="error color-inverse" role="alert"></p>
          </form>
        </figure>`
          )
        })

        return data;
      })
      .then(data => {
        reviewsSection.addEventListener('input', event => {
          const reviewId = event.target?.closest('figure')?.dataset?.reviewId;

          if (reviewId && event.target.value) {
            return submitFeedback(
              reviewId,
              "review",
              event.target.value,
              {
                success: reviewsSection.dataset.formSuccess,
                failure: reviewsSection.dataset.formFailure
              }
            );
          }
        });

        return data;
      })
      .catch(error => {
        errorsElement.textContent = reviewsSection.dataset.reviewsFetchFailureTranslation;
        console.error(error);
      })
      .finally(() => {
        reviewsWrapper.ariaBusy = false;
        reviewsSection.querySelector('.visual-loading-animation').style.display = 'none';
      });
  }
}

async function submitFeedback(id, resourceType, vote, messages) {
  let alertElement = document.getElementById(`${resourceType}-${id}`).querySelector('[role="alert"]');

  alertElement.textContent = "";

  return fetch(`https://api.yotpo.com/${resourceType}s/${id}/vote/${vote}`)
    .then(response => response.json())
    .then(data => alertElement.textContent = messages.success)
    .catch(error => {
      alertElement.textContent = messages.failure;
      throw new Error(error);
    })
}

function focusUnfocusableElement(element) {
  element.tabIndex = -1;
  element.focus();
}

function localizedSubmissionDate(datetime) {
  return new Date(datetime)
    .toLocaleDateString(
      undefined,
      {
        dateStyle: "medium"
      }
    );
}